// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AngleDownLarge: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 7" width={width} height={height}>
            <path
                fill="currentColor"
                d="M5.647 6.353a.5.5 0 0 0 .706 0l5-5a.5.5 0 0 0 0-.706.5.5 0 0 0-.706 0L6 5.294 1.353.647a.5.5 0 0 0-.706 0 .5.5 0 0 0 0 .706z"
            />
        </svg>
    );
};

export default React.memo(AngleDownLarge);
